import Vue from 'vue'
import { temAcesso, temAcessoView } from '@/shared/auth/temAcesso'
import { notificationSystem } from './vue-configs/vuetoastrconfig'
import masker from '@/shared/mask/masker'

Vue.prototype.$temAcesso = regra => {
    return temAcesso(regra)
}

Vue.prototype.$temAcessoView = regra => {
    return temAcessoView(regra)
}

Vue.prototype.$mask = (value, mask) => {
    return masker(value, mask)
}

Vue.prototype.$maskCpfCnpj = value => {
    if (value) {
        if (value.length == 11) {
            return masker(value, '###.###.###-##')
        } else if (value.length == 14) {
            return masker(value, '##.###.###/####-##')
        }
    }
    return ''
}

Vue.prototype.$maskCep = value => {
    return masker(value, '#####-###')
}

Vue.prototype.$maskTelefone = value => {
    return masker(value, ['(##) #####-####', '(##) ####-####'])
}

Vue.prototype.$maskDate = value => {
    return value ? Vue.moment(value).format('DD/MM/YYYY') : ''
}

Vue.prototype.$maskDateTime = value => {
    return value ? Vue.moment(value).format('DD/MM/YYYY HH:mm') : ''
}

Vue.prototype.$toastConfig = notificationSystem.options

Vue.prototype.$download = (data, filename, mime) => {
    var blob = new Blob([data], {
        type: mime || 'application/octet-stream'
    })
    if (typeof window.navigator.msSaveBlob !== 'undefined') {
        window.navigator.msSaveBlob(blob, filename)
    } else {
        var blobURL = window.URL.createObjectURL(blob)
        var tempLink = document.createElement('a')
        tempLink.style.display = 'none'
        tempLink.href = blobURL
        tempLink.setAttribute('download', filename)
        if (typeof tempLink.download === 'undefined') {
            tempLink.setAttribute('target', '_blank')
        }
        document.body.appendChild(tempLink)
        tempLink.click()
        document.body.removeChild(tempLink)
        window.URL.revokeObjectURL(blobURL)
    }
}

Vue.prototype.$cpfValido = cpf => {
    if (cpf.length > 11) {
        return false
    }

    while (cpf.length !== 11) {
        cpf = '0' + cpf
    }

    var igual = true
    for (let i = 1; i < 11 && igual; i++) {
        if (cpf[i] !== cpf[0]) {
            igual = false
        }
    }

    if (igual || cpf === '12345678909') {
        return false
    }

    var numeros = [11]

    for (let i = 0; i < 11; i++) {
        numeros[i] = parseInt(cpf[i].toString())
    }

    var soma = 0
    for (let i = 0; i < 9; i++) {
        soma += (10 - i) * numeros[i]
    }

    var resultado = soma % 11
    if (resultado === 1 || resultado === 0) {
        if (numeros[9] !== 0) {
            return false
        }
    } else {
        if (numeros[9] !== 11 - resultado) {
            return false
        }
    }

    soma = 0
    for (let i = 0; i < 10; i++) {
        soma += (11 - i) * numeros[i]
    }

    resultado = soma % 11

    if (resultado === 1 || resultado === 0) {
        if (numeros[10] !== 0) {
            return false
        }
    } else {
        if (numeros[10] !== 11 - resultado) {
            return false
        }
    }
    return true
}

Vue.prototype.$cnpjValido = cnpj => {
    if (
        cnpj == '00000000000000' ||
        cnpj == '11111111111111' ||
        cnpj == '22222222222222' ||
        cnpj == '33333333333333' ||
        cnpj == '44444444444444' ||
        cnpj == '55555555555555' ||
        cnpj == '66666666666666' ||
        cnpj == '77777777777777' ||
        cnpj == '88888888888888' ||
        cnpj == '99999999999999' ||
        cnpj.length != 14
    ) {
        return false
    }

    // Calculo do 1o. Digito Verificador
    let num = 0
    let sm = 0
    let peso = 2

    for (let i = 11; i >= 0; i--) {
        num = parseInt(cnpj[i].toString())
        sm = sm + num * peso
        peso = peso + 1
        if (peso == 10) {
            peso = 2
        }
    }

    let dig13
    let r = sm % 11
    if (r == 0 || r == 1) {
        dig13 = '0'
    } else {
        dig13 = `${11 - r}`
    }

    // Calculo do 2o. Digito Verificador
    sm = 0
    peso = 2
    for (let i = 12; i >= 0; i--) {
        num = parseInt(cnpj[i].toString())
        sm = sm + num * peso
        peso = peso + 1
        if (peso == 10) {
            peso = 2
        }
    }

    let dig14
    r = sm % 11
    if (r == 0 || r == 1) {
        dig14 = '0'
    } else {
        dig14 = `${11 - r}`
    }

    if (dig13 == cnpj[12] && dig14 == cnpj[13]) return true
    return false
}
